export default __webpack_public_path__ + "static/media/Headdress of the Grand Monarch.b396c359.jpg";